export default "__VITE_ASSET__4737a656__"